var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'moral-detail',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      moral: {
        moral_title: null,
        moral_start_date: null,
        moral_end_date: null,
        reference: null
      },
      moralDetails: [],
      usertypes: []
    }
  },
  computed: {
    moralEdit () {
      return this.$store.getters.moralEdit
    },
    moralEditDetail () {
      return this.$store.getters.moralEditDetail
    },
    moralEditTarget () {
      return this.$store.getters.moralEditTarget
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        self.moral.moral_title = self.moralEdit['moral-title']
        self.moral.moral_start_date = self.moralEdit['moral-start-date-format']
        self.moral.moral_end_date = self.moralEdit['moral-end-date-format']
        self.moral.reference = self.moralEdit['reference']
        for (var i=0; i < self.moralEditDetail.length; i++) {
          var morals = {
            moral_detail_id: self.moralEditDetail[i].id,
            check_content: self.moralEditDetail[i].attributes['check-content'],
            check_image: self.moralEditDetail[i].attributes['check-image-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp,
            sub_title: self.moralEditDetail[i].attributes['sub-title'],
            guideline_content: self.moralEditDetail[i].attributes['guideline-content'],
            yes_answer_add: self.moralEditDetail[i].attributes['yes-answer-add'],
            no_answer_add: self.moralEditDetail[i].attributes['no-answer-add']
          }
          self.moralDetails.push(morals)
        }

        for (var i=0; i < self.moralEditTarget.length; i++) {
          self.usertypes.push(self.moralEditTarget[i].attributes['user-type-name'])
        }
      }
      this.$store.dispatch('MORAL_EDIT', { id: this.$route.params.id, data: data, callback: callback })
    },
    goBack: function () {
      if (window.sessionStorage.getItem("moral_result") == 'on') {
        this.$router.push({ path: '/moral_result_list/'})
      } else {
        this.$router.push({ path: '/moral_list/'})
      }
    },
    content: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-detail.js